export default __webpack_public_path__ + "static/18_wakacje-ffa54d2d60bab3e6ed382fcb097bc7e1.png";